import React from 'react'
import { AppRouter } from 'Router'
import { WpAuthProvider } from 'services/auth/WpAuthProvider'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import { KindeProvider } from '@kinde-oss/kinde-auth-react'

const KINDE_CLIENT_ID = process.env.REACT_APP_KINDE_CLIENT_ID
const KINDE_DOMAIN = process.env.REACT_APP_KINDE_DOMAIN
const KINDE_REDIRECT_URI = process.env.REACT_APP_KINDE_REDIRECT_URL
const KINDE_LOGOUT_URI = process.env.REACT_APP_KINDE_LOGOUT_URL
const KINDE_AUDIENCE = process.env.REACT_APP_KINDE_AUDIENCE

function App() {
  return (
    <ErrorBoundary>
      <KindeProvider
        clientId={KINDE_CLIENT_ID as string}
        domain={KINDE_DOMAIN as string}
        redirectUri={KINDE_REDIRECT_URI as string}
        logoutUri={KINDE_LOGOUT_URI as string}
        audience={KINDE_AUDIENCE as string}
        // onRedirectCallback={(user, appState): any => {
        //   //@ts-ignore
        //   if (appState?.redirectTo) {
        //     //@ts-ignore
        //     window.location = appState?.redirectTo
        //   }
        // }}
      >
        <WpAuthProvider>
          <AppRouter />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </WpAuthProvider>
      </KindeProvider>
    </ErrorBoundary>
  )
}

export default App
